import styled from 'styled-components';
import media from 'styled-media-query';

import colors from 'themes/Main';

const { darkBlue, gray05 } = colors;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 80px;
  margin-bottom: 16px;
  padding-left: 110px;
  background-color: ${darkBlue};
  border-bottom: 1px solid ${gray05};

  ${media.lessThan('medium')`
    justify-content: flex-end;

    > div {
      display: none;
    }
  `}
`;

export const Logo = styled.img`
  margin-right: 32px;
`;
